const HEADING_SELECTOR = "h1, h2";
const BODY_SELECTOR = "p, li, dd, .home--hero__tagline, .icon-grid--item";
const CTA_SELECTOR = "a.btn, button.btn, .btn";

export function initRevealAnimations() {
  const main = document.querySelector("main");
  if (!main) return;

  const prefersReducedMotion = window
    .matchMedia("(prefers-reduced-motion: reduce)")
    .matches;

  const sections = Array.from(main.querySelectorAll("section"));
  if (!sections.length) return;

  const elements = [];

  sections.forEach((section) => {
    // Skip sections that explicitly opt out
    if (section.hasAttribute("data-reveal-disabled")) return;

    const headingEls = Array.from(section.querySelectorAll(HEADING_SELECTOR));
    const bodyEls = Array.from(section.querySelectorAll(BODY_SELECTOR));
    const ctaEls = Array.from(section.querySelectorAll(CTA_SELECTOR));

    let index = 0;

    const addGroup = (group) => {
      group.forEach((el) => {
        if (!el || el.hasAttribute("data-reveal-ignore")) return;
        // Avoid assigning multiple times
        if (el.hasAttribute("data-reveal")) return;
        el.setAttribute("data-reveal", "true");
        el.style.setProperty("--reveal-index", String(index));
        index += 1;
        elements.push(el);
      });
    };

    addGroup(headingEls);
    addGroup(bodyEls);
    addGroup(ctaEls);
  });

  if (!elements.length) return;

  // If user prefers reduced motion, show everything immediately without animation.
  if (prefersReducedMotion) {
    elements.forEach((el) => {
      el.classList.add("reveal-visible");
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("reveal-visible");
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.25,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  elements.forEach((el) => observer.observe(el));
}

